/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "UpdateWageSettingRequest": {
            "fields": {
              "wageSetting": {
                "type": ".squareup.team_api.WageSetting",
                "id": 1,
                "rule": "optional"
              },
              "teamMemberId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "UpdateWageSettingResponse": {
            "fields": {
              "wageSetting": {
                "type": ".squareup.team_api.WageSetting",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.UpdateWageSettingRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.UpdateWageSettingResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents an update request for the `WageSetting` object describing a `TeamMember`.
 * --
 *
 * SOURCE UpdateWageSettingRequest @ squareup/team_api/endpoints/update-wage-setting.proto at 23:1
 */
export const UpdateWageSettingRequest = $root.lookupType('squareup.team_api.UpdateWageSettingRequest');
fixType(UpdateWageSettingRequest, {
  wageSetting: {
    required: true
  },
  teamMemberId: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateWageSettingRequest);
/**
 * --
 * @desc Represents a response from an update request containing the updated `WageSetting` object
 * or error messages.
 * --
 *
 * SOURCE UpdateWageSettingResponse @ squareup/team_api/endpoints/update-wage-setting.proto at 46:1
 */
export const UpdateWageSettingResponse = $root.lookupType('squareup.team_api.UpdateWageSettingResponse');
fixType(UpdateWageSettingResponse);
Builder.createAndAttachToType(UpdateWageSettingResponse);